<template>
  <div class="container">
    <div class="box transference-form">
      <!-- Header -->
      <div class="columns is-vcentered form-header">
        <div class="column is-narrow">
          <div class="multi-money-logo">
            <span class="logo-icon">✱</span>
            <span class="logo-text">multi<br />money</span>
          </div>
        </div>
        <div class="column has-text-centered">
          <h1 class="title is-3">
            {{ $t("ach transfer order") }}
          </h1>
        </div>
        <div class="column is-narrow"></div>
      </div>

      <!-- Sección 1: Datos de la cuenta a debitar -->
      <div class="form-section">
        <div class="section-header has-background-grey-light has-text-centered">
          <p class="has-text-weight-bold">
            {{ $t("1. account data to be debited (origin)") }}
          </p>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{
                $t("account number to be debited in (q):")
              }}</label>
              <div class="control">
                <input
                  class="input is-borderless"
                  type="text"
                  v-model="meta.debit_account_number"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("account name:") }}</label>
              <div class="control">
                <input
                  class="input is-borderless"
                  type="text"
                  v-model="meta.account_name"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección 2: Datos del destinatario -->
      <div class="form-section">
        <div class="section-header has-background-grey-light has-text-centered">
          <p class="has-text-weight-bold">
            {{ $t("2. recipient data (destination bank)") }}
          </p>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("destination bank:") }}</label>
              <div class="control">
                <input
                  class="input is-borderless"
                  type="text"
                  v-model="meta.destination_bank"
                  :placeholder="$t('industrial bank')"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("account type (q):") }}</label>
              <div class="control">
                <input
                  class="input is-borderless"
                  type="text"
                  v-model="meta.account_type"
                  :placeholder="$t('savings (q)')"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{
                $t("other bank account number (q):")
              }}</label>
              <div class="control">
                <input
                  class="input is-borderless"
                  type="text"
                  v-model="meta.other_bank_account_number"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("recipient name:") }}</label>
              <div class="control">
                <input
                  class="input is-borderless"
                  type="text"
                  v-model="meta.recipient_name"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección 3: Detalles de la transferencia -->
      <div class="form-section">
        <div class="section-header has-background-grey-light has-text-centered">
          <p class="has-text-weight-bold">{{ $t("3. transfer details") }}</p>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("amount (q):") }}</label>
              <div class="control">
                <input
                  class="input is-borderless"
                  type="number"
                  v-model="meta.amount"
                  step="0.01"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("description:") }}</label>
              <div class="control">
                <input
                  class="input is-borderless"
                  type="text"
                  v-model="meta.description"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sección 4: Notificaciones -->
      <div class="form-section">
        <div class="section-header has-background-grey-light has-text-centered">
          <p class="has-text-weight-bold">{{ $t("4. notifications") }}</p>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{
                $t("email for notification (1):")
              }}</label>
              <div class="control">
                <input
                  class="input is-borderless"
                  type="email"
                  v-model="meta.notification_email_1"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{
                $t("email for notification (2):")
              }}</label>
              <div class="control">
                <input
                  class="input is-borderless"
                  type="email"
                  v-model="meta.notification_email_2"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Autorización -->
      <div class="authorization-text">
        <p class="is-size-5 has-text-justified">
          {{
            $t(
              "i authorize banco multimoney, s.a to debit the indicated account and carry out the ach transfer under the assigned terms."
            )
          }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { warning_message, get, generate_error_message_text } from "@/utils";

export default {
  name: "TransfereceRequestComplete",
  components: {},
  data() {
    return {
      error: "",
      request: null,
      meta: {
        debit_account_number: "",
        account_name: "",
        destination_bank: "",
        account_type: "",
        other_bank_account_number: "",
        recipient_name: "",
        amount: "",
        description: "",
        notification_email_1: "",
        notification_email_2: "",
      },
    };
  },
  methods: {
    load_request(uuid) {
      get("/account-request/transference/complete", { uuid: uuid })
        .then((response) => {
          this.request = response;
        })
        .catch((error) => {
          this.error = generate_error_message_text(error);
        });
    },
  },
  mounted() {
    let uuid = this.$route.params.uuid;
    if (uuid) this.load_request(uuid);
    else error = this.$t("invalid request id");
  },
};
</script>

<style scoped>
.transference-form {
  max-width: 800px;
  margin: 0 auto;
  /* background: white; */
  font-family: Arial, sans-serif;
}

.form-header {
  /* border-bottom: 1px solid #ddd; */
  padding-bottom: 20px;
  margin-bottom: 30px;
}

.multi-money-logo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.logo-icon {
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
}

.logo-text {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.2;
  color: #ffffff;
}

.order-info {
  display: flex;
  gap: 20px;
  margin-bottom: 10px;
}

.form-section {
  margin-bottom: 25px;
}

.section-header {
  padding: 8px 15px;
  border-radius: 15px;
  margin-bottom: 15px;
}

.section-header p {
  margin: 0 !important;
  color: #000 !important;
}

/* Estilos personalizados para los inputs sin borde */
.input.is-borderless {
  border: none;
  border-bottom: 1px solid #ccc;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
  box-shadow: none;
  background: transparent;
}

.input.is-borderless:focus {
  border-bottom: 2px solid #007bff;
  box-shadow: none;
}

.input.is-borderless::placeholder {
  color: #999;
  font-style: italic;
}

/* Ajustar el tamaño de las etiquetas */
/* .label.is-small {
  font-size: 12px;
  color: #333;
  font-weight: normal;
  margin-bottom: 5px;
} */

.authorization-text {
  margin-top: 30px;
  padding: 15px 0;
}

.authorization-text p {
  line-height: 1.4;
  color: #ffffff;
}

/* Responsive adjustments */
@media screen and (max-width: 768px) {
  .form-header {
    flex-direction: column;
    text-align: left !important;
  }

  .order-info {
    justify-content: flex-start;
  }

  .columns {
    margin: 0 !important;
  }

  .column {
    padding: 0.5rem !important;
  }
}

/* Ajustar el espaciado de Bulma */
.field {
  margin-bottom: 1rem;
}

.columns {
  margin-bottom: 0 !important;
}

.column {
  padding: 0.75rem 1rem;
}
</style>
